import React, { useState, useEffect } from "react";
import { Navigation } from "./components/navigation";
import { Header } from "./components/header";
import { Passions } from "./components/passions";
import { About } from "./components/about";
import { Techstack } from "./components/techstack";
import { Gallery } from "./components/gallery";
import { Testimonials } from "./components/testimonials";
import { Team } from "./components/team";
import { DownloadList } from "./components/downloadList";
import { Contact } from "./components/contact";
import AIChatBox from "./components/AIChatBox";
import JsonData from "./data/data.json";
import SmoothScroll from "smooth-scroll";
import "./App.css";

export const scroll = new SmoothScroll('a[href*="#"]', {
  speed: 1000,
  speedAsDuration: true,
});

const App = () => {
  const [landingPageData, setLandingPageData] = useState({});
  useEffect(() => {
    setLandingPageData(JsonData);
  }, []);

  return (
    <div>
      <Navigation />

      <AIChatBox data={landingPageData} />
      <Header data={landingPageData.Header} />
      <Passions data={landingPageData.Passions} />
      <About data={landingPageData.About} />
      <Techstack data={landingPageData.Techstack} />
      <Gallery data={landingPageData.Gallery} />
      <Testimonials data={landingPageData.Testimonials} />
      <Team data={landingPageData.Team} />
      <DownloadList data={landingPageData.Downloads} />
      <Contact data={landingPageData.Contact} />
    </div>
  );
};

export default App;
